import { render } from "./Ignition.vue?vue&type=template&id=33438161"
import script from "./Ignition.vue?vue&type=script&lang=js"
export * from "./Ignition.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__